var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.83542 0.186257C7.8609 0.137564 7.89758 0.0956094 7.94246 0.063848C7.98734 0.0320865 8.03913 0.0114261 8.09357 0.00356748C8.14801 -0.00429115 8.20354 0.000876716 8.25558 0.0186457C8.30763 0.0364146 8.35471 0.0662765 8.39294 0.105773L8.79832 0.37472C8.89533 0.44894 8.96558 0.55262 8.99851 0.670161C9.00901 0.815649 8.96374 0.959683 8.87189 1.07308L4.44124 8.19316C4.34115 8.35463 4.26408 8.46211 4.18801 8.56959C4.12435 8.66945 4.03747 8.75245 3.93477 8.81154C3.85627 8.86668 3.7712 8.91185 3.68153 8.94601C3.59223 8.97925 3.49804 8.9975 3.40277 9C3.22966 8.99589 3.06184 8.93961 2.92132 8.83853C2.70245 8.67531 2.51377 8.47518 2.3638 8.24715L0.0841638 5.02329C0.0493422 4.98882 0.0240377 4.94594 0.0107084 4.89882C-0.00262097 4.85169 -0.00352207 4.80192 0.00809259 4.75435C0.0345207 4.67452 0.0776867 4.60124 0.134711 4.53939L0.616162 4.10948C0.675819 4.04601 0.757405 4.00759 0.844376 4.002C0.929278 4.01494 1.00857 4.05228 1.07259 4.10948L3.27465 5.96361L7.83542 0.186257Z",
    fill: "#228B22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.bf694de5d3fd93a28a95caf0c91b5ec6.svg";
export { ForwardRef as ReactComponent };